<template>
    <Teleport to="body">
        <TransitionGroup name="toast" tag="div" class="fixed bottom-4 right-4 z-toast space-y-2">
            <div
                v-for="toast in toastStore.toasts"
                :key="toast.id"
                class="p-4 bg-white rounded-lg flex items-center gap-2 z-100 relative shadow-md border border-gray-light w-full max-w-120"
            >
                <component
                    :is="getIcon(toast.type)"
                    class="size-6 self-start"
                    :class="[
                        toast.type === 'success' && 'text-success',
                        toast.type === 'error' && '  text-error',
                        toast.type === 'info' && '  text-primary-beet',
                        toast.type === 'warning' && ' text-gray-dark',
                    ]"
                />
                <span class="flex-1">
                    {{ toast.title }}
                    <span v-if="toast.message">- {{ toast.message }}</span>
                </span>
                <div class="ml-3">
                    <IconButton
                        :aria-label="__('close')"
                        size="size-4"
                        area-size="size-5"
                        :class="[
                            toast.type === 'success' && 'text-success',
                            toast.type === 'error' && '  text-error',
                            toast.type === 'info' && '  text-primary-beet',
                            toast.type === 'warning' && ' text-gray-dark',
                        ]"
                        @click="() => toastStore.removeToast(toast.id)"
                    >
                        <XIcon class="size-4" />
                    </IconButton>
                </div>
            </div>
        </TransitionGroup>

        <Transition name="fade">
            <div
                v-if="toastStore.hasErrorOrWarningToasts()"
                class="fixed h-screen w-screen left-0 top-0 bg-gray-dark transition-opacity z-toast-backdrop opacity-75 duration-300"
                :class="{ 'pointer-events-none': !toastStore.hasErrorOrWarningToasts() }"
                @click="toastStore.removeAllToasts()"
            />
        </Transition>
    </Teleport>
</template>

<script setup lang="ts">
    import { useToastStore, ToastType } from '../stores/snackbar';
    import IconButton from './IconButton.vue';
    import { __ } from '@/js/stores/expressions';
    import { CheckIcon, CircleAlertIcon, InfoIcon, TriangleAlertIcon, XIcon } from '@lucide/vue';
    import type { Component } from 'vue';
    const toastStore = useToastStore();

    const getIcon = (type: ToastType): Component => {
        switch (type) {
            case 'success':
                return CheckIcon;
            case 'error':
                return TriangleAlertIcon;
            case 'warning':
                return CircleAlertIcon;
            default:
                return InfoIcon;
        }
    };
</script>

<style scoped>
    .toast-enter-active,
    .toast-leave-active {
        transition:
            opacity 0.3s ease,
            transform 0.3s ease;
    }

    .toast-enter-from {
        opacity: 0;
        transform: translateY(1rem);
    }

    .toast-leave-to {
        opacity: 0;
        transform: translateY(1rem);
    }
</style>
